module.exports = __webpack_public_path__ + "img/closeicon.8de349e3.svg";